module.exports = require("./../../_gen/starling/utils/Execute");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/utils/Execute.js
// module id = 244
// module chunks = 0